<template>
  <div class="formWrapper filled">
    <b-row>
      <b-col cols="12">
        <div class="pm-header-top floatCss d-flex justify-content-between">
          <div class="pm-logo-left d-flex">
            <div class="pm-logo">
              <img
                :src="logoSrc"
                style="width: 162px; height: auto;"
              >
            </div>
            <div class="pm-logo-text">
              <h3>NIRVANA PRESTIGE PTE. LTD.<span>(UEN NO: 201602195C)</span></h3>
              <h4>AS THE AUTHORISED agent OF THIAN LENG CHONG TOH TONG</h4>
            </div>
          </div>
          <div class="pm-right">
            <div class="pm-right-cn">
              <div class="pm-right-label">
                File No:
              </div>
              <div class="pm-right-dt" />
            </div>
            <div class="pm-right-bottom">
              <p>Sales Order No: {{ formData.orderNo || 'N-12345' }}</p>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12">
        <b-row>
          <b-col
            cols="5"
            md="5"
            lg="5"
          >
            <div class="cm-header-info">
              <p>Address: 472 Changi Road Singapore 419890</p>
            </div>
          </b-col>
          <b-col
            cols="7"
            md="7"
            lg="7"
          >
            <div class="cm-header-info-right">
              <div class="cm-header-info">
                <p>Tel: +65 68909719</p>
              </div>
              <div class="cm-header-info">
                <p>Website: Thianleng.sg</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12">
        <div class="pp-section-tittle pp-gap-15">
          <h2>installment payment plan 分期付款计划</h2>
        </div>
      </b-col>
    </b-row>
    <b-row class="payment-plan-section">
      <b-col cols="12">
        <b-row class="pp-wrapper-row font-pdf-custom">
          <b-col
            cols="6"
            md="6"
            lg="6"
          >
            <div class="pp-nt-block floatCss">
              <div class="pp-nt-text pp-nt-wd-1 floatCss">
                I,
              </div>
              <div class="pp-nt-text-input pp-nt-wd-2">
                {{ formData.customerName || '-' }}
              </div>
            </div>
          </b-col>
          <b-col
            cols="6"
            md="6"
            lg="6"
          >
            <div class="pp-nt-block-container floatCss">
              <div class="pp-nt-block floatCss">
                <div class="pp-nt-text pp-nt-wd-2 floatCss">
                  NRIC No.
                </div>
                <div class="pp-nt-text-input pp-nt-wd-3">
                  {{ formData.customerNric || '-' }}
                </div>
              </div>
              <div class="pp-nt-text3">
                the purchaser of
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="pp-wrapper-row font-pdf-custom">
          <b-col
            cols="6"
            md="6"
            lg="6"
          >
            <div class="pp-nt-block floatCss">
              <div class="pp-nt-text pp-nt-wd-a1 floatCss">
                Sales Order No.
              </div>
              <div class="pp-nt-text-input pp-nt-wd-a2">
                {{ formData.orderNo || 'N-12345' }}
              </div>
            </div>
          </b-col>
          <b-col
            cols="6"
            md="6"
            lg="6"
          >
            <div class="pp-nt-block floatCss">
              <div class="pp-nt-text pp-nt-wd-2 floatCss">
                Niche No.
              </div>
              <div class="pp-nt-text-input pp-nt-wd-2">
                {{ formData.nicheNo || '-' }}
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="pp-wrapper-row font-pdf-custom">
          <b-col cols="12">
            <div class="pp-single-row floatCss">
              <div class="pp-single-sd1">
                do hereby request for the balance of the purchase prices to be settled by an installment plan.
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="pp-check-wrapper">
          <b-col cols="12">
            <div class="pp-section-tittle">
              <h2>mode of payment</h2>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="pp-check-group">
              <div class="pp-check-single">
                Via Counter or Mobile App
              </div>
              <div class="pp-check-single">
                Direct Debit via Credit Card
              </div>
              <div class="pp-check-single">
                Credit Card IPP
              </div>
              <div class="pp-check-single">
                Giro or eGiro
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="instalment-details-section">
          <b-col cols="12">
            <div class="pp-section-tittle">
              <h2>Installment Plan Details</h2>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="pp-instalment-wrapper floatCss">
              <div class="pp-instalment-single floatCss">
                <div class="instalment-left-tittle floatCss">
                  Installment Plan Amount (SGD)
                </div>
                <div class="instalment-right-input floatCss">
                  ${{ numberFormat(formData.installmentAmount) }}
                </div>
              </div>
              <div class="pp-instalment-single floatCss">
                <div class="instalment-left-tittle floatCss">
                  Installment Tenure
                </div>
                <div class="instalment-right-input floatCss">
                  {{ formData.installmentTenure }}
                </div>
              </div>
              <div class="pp-instalment-single floatCss">
                <div class="instalment-left-tittle floatCss">
                  Monthly Installment Amount
                </div>
                <div class="instalment-right-input floatCss">
                  ${{ numberFormat(formData.monthlyInstallment) }}
                </div>
              </div>
              <div class="pp-instalment-single floatCss">
                <div class="instalment-left-tittle floatCss">
                  Final Installment Amount
                </div>
                <div class="instalment-right-input floatCss">
                  ${{ numberFormat(formData.finalInstallment) }}
                </div>
              </div>
              <div class="pp-instalment-single floatCss">
                <div class="instalment-left-tittle floatCss">
                  Installment Due Date
                </div>
                <div class="instalment-right-content floatCss">
                  <div class="pp-instalment-single2 floatCss">
                    <div class="pp-instalment-tittle-2 floatCss">
                      Commencing on 1st day of
                    </div>
                    <div class="instalment-right-input2 floatCss">
                      {{ formData.commencingDate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="pp-instalment-single floatCss">
                <div class="instalment-left-tittle floatCss" />
                <div class="instalment-right-content floatCss">
                  <p>and thereafter on the 1st day of each month</p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="pp-intalment-text">
          <b-col cols="12">
            <div class="pp-bottom-info-text">
              <p>I hereby agree that the terms and conditions contains in the Sales Order remains unchanged and the Company reserved the sole right in amending or rejecting the Installment Plan without assigning any reason thereto.</p>
            </div>
          </b-col>
        </b-row>
        <b-row class="pp-service-text">
          <b-col cols="12">
            <div class="pp-section-tittle">
              <h2>PARTICULARS of service advisor  服务顾问资料</h2>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="service-pp-info floatCss">
              <div class="service-pp-left-info">
                Agency 区代理
              </div>
              <div class="service-pp-right-info">
                {{ formData.agency }}
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="service-pp-info floatCss">
              <div class="service-pp-left-info">
                Service Advisor 服务顾问
              </div>
              <div class="service-pp-right-info">
                {{ formData.serviceAdvisor }}
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="footer-signature-area">
          <b-col cols="12">
            <div class="pp-signature-area floatCss">
              <p>Purchaser 购买者签名</p>
            </div>
          </b-col>
          <b-col cols="12">
            <b-row>
              <b-col
                cols="6"
                md="6"
                lg="6"
              >
                <div class="pp-signature-block floatCss">
                  <img
                    v-if="formData.sign"
                    :src="formData.sign"
                    alt="signature"
                  >
                  <span v-else>Sign here</span>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12">
            <div
              class="pp-signature-area floatCss"
            >
              <h4>Name 姓名: {{ formData.customerName }}</h4>
              <h4>Date 日期: {{ formData.sign ? dateFormat() : '' }}</h4>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoSrc: require('@/assets/images/logo/thian-leng-logo.svg'),
      formData: JSON.parse(localStorage.getItem('installmentFormData')) || {},
    }
  },
}
</script>
